export default "__VITE_ASSET__CIM2XPym__"